import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SaveApplicationBidMutation,  IApplicationBidInput, IApplicationBid, GetApplicationBidsByIdQuery, DeleteApplicationBidMutation } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';

import { ApplicationBidApiService } from '../application-bid-api.service';

@Injectable({
    providedIn: 'root'
  })
  export class ApplicationBidGqlService implements ApplicationBidApiService {

    constructor(
      private apollo: Apollo
    ) { }

    public update(applicationBid: IApplicationBidInput): Observable<any> {
      //console.log(`ApplicationBidApi.update()`);
      return this.apollo
        .mutate({
          mutation: SaveApplicationBidMutation,
          variables : {
            applicationBid
          }
        })
        .pipe(map(result => result.data['saveApplicationBid'].id as string));
    }

    public delete(applicationBid: IApplicationBidInput): Observable<any> {
      //console.log(`ApplicationBidApi.delete()`);
      return this.apollo
        .mutate({
          mutation: DeleteApplicationBidMutation,
          variables : {
            applicationBid
          }
        })
        .pipe(map(result => result.data['deleteApplicationBid'].id as string));
    }

    public getApplicationBidList(applicationId: string): Observable<IApplicationBid[]> {
      return this.apollo
        .query ({
          query: GetApplicationBidsByIdQuery,
          variables: {
            applicationId: applicationId,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => result.data['applicationBids'] as IApplicationBid[]));
    }
  }
